(async function () {
  // Opens any linked accordions
  const faq_opened = window.location.hash;
  if (faq_opened) {
    for (const $accordion of document.querySelectorAll(`.faq details.accordion[data-anchor="${faq_opened.substring(1)}"]`)) {
      console.warn($accordion);
      $accordion.setAttribute('open', true);
      $accordion.setAttribute('aria-expanded', 'true');
    }
  }
})();